import { Route, Routes, Navigate } from "react-router-dom";
import { routes, authRoutes, routeNames } from "../constants/routes";
import PrivateRoute from "../components/privateRoute/PrivateRouting";
import { useEffect, useState } from "react";
import { getAuthTokenData } from "../utils/tokenUtils";
import { roles } from "../constants/constants";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import NotFound from "./notFound/NotFound";

const Index: React.FC = () => {
  const { token, user } = useSelector((state: RootState) => state.auth);
  console.log("🚀 ~ user:", user)
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const { isAuthenticated } = getAuthTokenData();
    setIsAuthenticated(isAuthenticated);

    const handleStorageChange = () => {
      const { isAuthenticated } = getAuthTokenData();
      setIsAuthenticated(isAuthenticated);
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [token]);

  return (
    <Routes>
      {routes.map((route, i) => (
        <Route
          key={i}
          path={route.path}
          element={
            <PrivateRoute
              isAuthenticated={isAuthenticated}
              role={roles.superAdmin}
              allowedRoles={[roles.superAdmin, roles.propertyOwner]}
              redirectTo={routeNames.login}
              Component={route.component}
            />
          }
        />
      ))}
      {authRoutes.map((route, i) => (
        <Route
          key={i}
          path={route.path}
          element={
            !isAuthenticated ? (
              <route.component />
            ) : user.role === "SuperAdmin" ?
              <Navigate to={routeNames.dashboardHome} /> : <Navigate to={routeNames.buildings} />

          }
        />
      ))}
      <Route
        path="/"
        element={
          isAuthenticated ? user.role === "SuperAdmin" ?
            <Navigate to={routeNames.dashboardHome} /> : <Navigate to={routeNames.buildings} />
            : (
              <Navigate to={routeNames.login} />
            )
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Index;
